module.exports = __webpack_public_path__ + "static/media/yang_peter.25884904.png";